export default __webpack_public_path__ + "static/img39v-7047b387bd65d99f9571d84ce5314455.jpg";